export enum MediaMinWidths {
    SmallestPhone = 320,
    Small = 480,
    Medium = 768,
    Large = 960,
}
